<div>
  <div class="header-title">
    <span [id]="identifierService.labelId('releasePatientDialog', 'headerTitle')" style="flex: 1">
      {{ labels['label.gb.rel_pat'] }}
    </span>
    <!-- <mat-icon (click)="onNoClick()" class="col-sm-1" [mat-dialog-close]="true">close</mat-icon> -->
  </div>
  <h6 [id]="identifierService.labelId('releasePatientDialog', 'relPat')" mat-dialog-title>{{ labels['label.gb.rel_pat'] }}</h6>
  @if (errorMsgs?.length !== 0) {
    <div class="errormsg">
      <ul>
        @for (err of errorMsgs; track err; let i = $index) {
          <li [id]="identifierService.listitemId('patient-list', 'error' + i)">
            {{ err }}
          </li>
        }
      </ul>
    </div>
  }

  @if (reasonForReasonFlag === 'D' && showInfoMessage) {
<div style="
            background-color: #ffc;
            border: 1px solid #999;
            padding: 5px;
            display: flex;
            margin: 5px 0;
        ">
      <p class="caption-1" [id]="identifierService.labelId('releasePatient', 'msgPa898')" [innerHTML]="labels['msg.pa898.text']"></p>
      <span class="closeIcon" style="font-weight: bold" (click)="hideInfoPanel()">x</span
        >
      </div>
    }

    <mat-dialog-content>
      @if (completedTransmissionCount > 0) {
        <p
          class="caption-1"
          [id]="identifierService.labelId('patient-list', 'caption_1')"
          [innerHTML]="translate('msg.pa051.prompt', completedTransmissionCount)"
        ></p>
      }
      @if (InCompletedTransmissionCount > 0) {
        <p
          class="caption-1"
          [id]="identifierService.labelId('patient-list', 'caption_2')"
          >
          {{ labels['label.gb.transmission_not_complete'] }}
        </p>
      }

      <merlin-section [sectionPadding]="false">
        <div class="sm merlin-dataTable">
          <table
            mat-table
            [dataSource]="patientDataSource"
                    [id]="
                        identifierService.datatableId(
                            'patient-list',
                            'patient-data'
                        )
                    "
            >
            <!-- Name Column -->
            <ng-container matColumnDef="lastName">
              <th [id]="identifierService.labelId('releasePatientDialog', 'thPatient')" mat-header-cell *matHeaderCellDef>
                {{ labels['label.gb.Patient'] }}
              </th>

              <td mat-cell *matCellDef="let element" >
                <a class="nav-link"
                  >@if (element.lastName) {
                  <span [id]="identifierService.labelId('releasePatientDialog', 'patientName')">{{ element.lastName }},</span>
                  } {{ element.middleName }} {{ element.firstName }}</a
                  >
                </td>
              </ng-container>
              <ng-container matColumnDef="patientNumber">
                <th [id]="identifierService.labelId('releasePatientDialog', 'thPrn')" mat-header-cell *matHeaderCellDef>
                  {{ labels['label.rpt.PRN'] }}
                </th>
                <td mat-cell *matCellDef="let element">
                  @if (element.patientNumber) {
                    <span [id]="identifierService.labelId('releasePatientDialog', 'patientNumber_' + element.patientNumber)">
                      {{ labels['label.gb.patient_id_prefix'] }}:
                      {{ element.patientNumber }}</span
                      >
                    }
                  </td>
                </ng-container>
                <!-- Name Column -->
                <ng-container matColumnDef="isTransmissionComplete">
                  <th [id]="identifierService.labelId('releasePatientDialog', 'thMessage')" mat-header-cell *matHeaderCellDef>
                    {{ labels['label.gb.message'] }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    @if (!element.isTransmissionComplete) {
                      <span [id]="identifierService.labelId('releasePatientDialog', 'unarchived_transmissions')">{{
                        labels['label.gb.unarchived_transmissions']
                      }}</span>
                    }
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
              </table>
            </div>
          </merlin-section>
          <div class="row">


            <div class="col-xs-5">

              <mat-form-field class="merlin-select full-width mat-release-dropdown" appearance="outline">
                <!-- <mat-error [id]="identifierService.labelId('patient-list', 'star')">*</mat-error> -->
                <mat-label [id]="
                            identifierService.labelId(
                                'patient-list',
                                'reason_for_release'
                            )
                        "><span [id]="identifierService.labelId('releasePatientDialog', 'reasonForPatientRelease')" style="color:red">* </span>{{ labels['label.gb.reason_for_patient_release'] }}
                </mat-label>
                <mat-select disableOptionCentering name="reason" value="B" (selectionChange)="reasonForSelected($event)" [(ngModel)]="reasonForReasonFlag">
                  <mat-option [value]="null">&nbsp;</mat-option>
                  <mat-option [id]="identifierService.listitemId('releasePatientDialog', 'transferred')" value="R">
                    {{ labels['label.gb.transferred_to_another_clinic'] }}
                  </mat-option>
                  <mat-option [id]="identifierService.listitemId('releasePatientDialog', 'explanted')" value="E">
                    {{ labels['label.gb.reason_explanted'] }}
                  </mat-option>
                  <mat-option [id]="identifierService.listitemId('releasePatientDialog', 'removed')" value="D">
                    {{ labels['label.gb.reason_removed'] }}
                  </mat-option>
                  <mat-option [id]="identifierService.listitemId('releasePatientDialog', 'expired')" value="X">
                    {{ labels['label.gb.expired'] }}
                  </mat-option>
                </mat-select>
                @if (reason.hasError('required')) {
                  <mat-error>Please choose a reason</mat-error>
                }
              </mat-form-field>
            </div>
          </div>
          @if (!isActivatorClinic && clinicDataSource?.data?.length) {
            <p class="caption-1" [id]="identifierService.labelId('patient-list', 'select_a_clinic')">
              {{ labels['label.gb.referringclinic_intro_text'] }}
            </p>
          }
          @if (isActivatorClinic) {
            <p class="caption-1" [id]="identifierService.labelId('patient-list', 'select_a_clinic')">
              {{ labels['label.gb.actclinic_release_intro_text'] }}
            </p>
          }

          @if (clinicDataSource?.data?.length || isActivatorClinic) {
            <merlin-section [sectionPadding]="false">
              <div class="sm merlin-dataTable">
            <table mat-table matSort matSortDisableClear (matSortChange)="sortChange($event)" [matSortActive]="sortActiveKey" [matSortDirection]="sortDirection"  [dataSource]="clinicDataSource" [id]="
                        identifierService.datatableId(
                            'patient-list',
                            'clinicDataSource'
                        )
                    ">
                  <!-- Clinic Name Column -->
                  <ng-container matColumnDef="name">
                    <th [id]="identifierService.labelId('releasePatientDialog', 'thClinicName')" mat-header-cell mat-sort-header *matHeaderCellDef>
                      {{ labels['label.gb.clinicname'] }}
                    </th>
                    <td [id]="identifierService.labelId('releasePatientDialog', 'tdClinicName')" mat-cell [ngClass]="{ eleName: element.name.length>= 100 }" *matCellDef="let element">
                      {{ labels[element.name] || element.name }}
                    </td>
                  </ng-container>
                  <!-- address Column -->
                  <ng-container matColumnDef="address">
                    <th [id]="identifierService.labelId('releasePatientDialog', 'thAddress')" mat-header-cell *matHeaderCellDef>
                      {{ labels['label.gb.address'] }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <div [id]="identifierService.labelId('releasePatientDialog', 'tdAddress')"> {{getAddress(element)}} </div>
                    </td>
                  </ng-container>
                  <!-- phone Number Column -->
                  <ng-container matColumnDef="phoneNumber">
                    <th [id]="identifierService.labelId('releasePatientDialog', 'thPhone')" mat-header-cell *matHeaderCellDef>
                      {{ labels['label.gb.phone_number'] }}
                    </th>
                    <td [id]="identifierService.labelId('releasePatientDialog', 'tdPhone')" mat-cell *matCellDef="let element">
                      {{ element.countryCode }}-{{ element.areaCode }}-{{
                      element.phoneNum
                      }}
                    </td>
                  </ng-container>
                  <!-- Id Column -->
                  <ng-container matColumnDef="selected">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element">
                      <mat-radio-button
                        [id]="identifierService.checkboxId('releasePatient', 'transferClinic_' + element.associatedCustApplId)"
                        color="primary"
                        [disabled] = "reasonForReasonFlag !== 'R'"
                        (change)="primaryClick(element)"
                                [checked]="
                                    element.associatedCustApplId === transferCustApplId
                                        ? true
                                        : false
                                "
                      ></mat-radio-button>
                    </td>
                  </ng-container>
                  <tr
                    mat-header-row
                    *matHeaderRowDef="clinicColumns; sticky: true"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: clinicColumns; let i = index"
                    [id]="identifierService.rowId('patient-list', '_' + i)"
                        [ngClass]="{
                            selected: selection.isSelected(row)
                        }"
                  ></tr>
                </table>
              </div>
            </merlin-section>
          }
          <div class="row">
            <div class="col-xs-12">
              <div
                class="text-error"
                [id]="identifierService.labelId('patient-list', 'req_field')"
                >
                * {{ labels['label.gb.required_field'] }}
              </div>
            </div>
          </div>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
          <button
            mat-raised-button
            mat-dialog-close
            color="accent"
            [id]="
                identifierService.buttonId('patient-list-release-patient', 'cancel')
            "
            >
            {{ labels['label.gb.button_cancel'] }}
          </button>
          @if (reasonForReasonFlag !== 'B' && reasonForReasonFlag !== '' && reasonForReasonFlag !== null) {
            <button
              mat-raised-button
              class="merlin-button"
              color="primary"
              [disabled]="!isTransmissionCompleted"
              cdkFocusInitial
              (click)="dropDownSelect()"
            [id]="
                identifierService.buttonId(
                    'patient-list-release-patient',
                    'releasea'
                )
            "
              >
              {{ labels['label.gb.release'] }}
            </button>
          }
          @if (reasonForReasonFlag === 'B' || reasonForReasonFlag === '' || reasonForReasonFlag === null) {
            <button
              mat-raised-button
              class="merlin-button"
              [disabled]="!isTransmissionCompleted"
              color="primary"
              cdkFocusInitial
              (click)="dropDownSelect()"
            [id]="
                identifierService.buttonId(
                    'patient-list-release-patient',
                    'releaseb'
                )
            "
              >
              {{ labels['label.gb.release'] }}
            </button>
          }
        </mat-dialog-actions>
      </div>